var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.isParallelCorpus
        ? [
            _c("CqlQueryBuilder", {
              model: {
                value: _vm.mainQuery,
                callback: function ($$v) {
                  _vm.mainQuery = $$v
                },
                expression: "mainQuery",
              },
            }),
          ]
        : _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "qb-par-wrap" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "control-label",
                      attrs: { for: "sourceVersion" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("search.parallel.queryForSourceVersion")
                        ) + "\n\t\t\t\t"
                      ),
                      _c("SelectPicker", {
                        attrs: {
                          id: "sourceVersion",
                          options: _vm.pSourceOptions,
                          "data-menu-width": "grow",
                          hideEmpty: "",
                        },
                        model: {
                          value: _vm.pSourceValue,
                          callback: function ($$v) {
                            _vm.pSourceValue = $$v
                          },
                          expression: "pSourceValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errorNoParallelSourceVersion
                    ? _c("span", { staticClass: "error" }, [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.$t("search.parallel.errorNoSourceVersion")
                            ) +
                            "\n\t\t\t"
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("CqlQueryBuilder", {
                    model: {
                      value: _vm.mainQuery,
                      callback: function ($$v) {
                        _vm.mainQuery = $$v
                      },
                      expression: "mainQuery",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.pTargets, function (field, index) {
                return _c(
                  "div",
                  { key: field.value, staticClass: "qb-par-wrap" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("search.parallel.queryForTargetVersion")
                          ) + "\n\t\t\t\t"
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "targetVersion",
                            attrs: {
                              type: "button",
                              title: _vm.$t("widgets.clickToRemove").toString(),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeTarget(field.value)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(field.label) +
                                "\n\t\t\t\t"
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("CqlQueryBuilder", {
                      key: field.value,
                      attrs: { value: _vm.targetQueries[index] },
                      on: {
                        input: function ($event) {
                          return _vm.changeTargetQuery(index, $event)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.pTargetOptions.length
                ? _c("div", { staticClass: "add-target-version form-group" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            _vm.pTargetValue.length
                              ? "search.parallel.addTargetVersion"
                              : "search.parallel.andCompareWithTargetVersions"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("SelectPicker", {
                          attrs: { options: _vm.pTargetOptions, hideEmpty: "" },
                          on: {
                            input: function ($event) {
                              return _vm.addTarget($event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pTargets.length
                ? _c("AlignBy", { attrs: { block: "" } })
                : _vm._e(),
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-default btn-sm",
          attrs: { type: "button" },
          on: { click: _vm.copyAdvancedQuery },
        },
        [_vm._v(_vm._s(_vm.$t("search.advanced.copyAdvancedQuery")))]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }